import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {Location, LocationQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const LOCATION_URL = `${API_URL}/location`
const GET_LOCATION_URL = `${API_URL}/location`

const getLocations = (query: string): Promise<LocationQueryResponse> => {
  return axios
    .get(`${GET_LOCATION_URL}?${query}`)
    .then((d: AxiosResponse<LocationQueryResponse>) => d.data)
}

const getLocationsArray = (limit = 10): Promise<Array<Location>> => {
  return axios.get(`${GET_LOCATION_URL}?enabled=true&items_per_page=${limit}`).then((d: AxiosResponse<any>) => {
    return d.data.data
  })
}

const getLocationById = (id: ID): Promise<Location | undefined> => {
  return axios
    .get(`${LOCATION_URL}/${id}`)
    .then((response: AxiosResponse<Response<Location>>) => response.data)
    .then((response: Response<Location>) => response.data)
}

const createLocation = (location: Location): Promise<Location | undefined> => {
  return axios
    .post(LOCATION_URL, location)
    .then((response: AxiosResponse<Response<Location>>) => response.data)
    .then((response: Response<Location>) => response.data)
}

const updateLocation = (location: Location): Promise<Location | undefined> => {
  return axios
    .put(`${LOCATION_URL}/${location._id}`, location)
    .then((response: AxiosResponse<Response<Location>>) => response.data)
    .then((response: Response<Location>) => response.data)
}

const deleteLocation = (locationId: ID): Promise<void> => {
  return axios.delete(`${LOCATION_URL}/${locationId}`).then(() => {})
}

const deleteSelectedLocations = (locationIds: Array<ID>): Promise<void> => {
  const requests = locationIds.map((id) => axios.delete(`${LOCATION_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getLocations,
  getLocationsArray,
  deleteLocation,
  deleteSelectedLocations,
  getLocationById,
  createLocation,
  updateLocation,
}
